import { OnInit } from '@angular/core';
var IconComponent = /** @class */ (function () {
    function IconComponent() {
    }
    Object.defineProperty(IconComponent.prototype, "iconClass", {
        get: function () {
            var cssClass = "fas fa-" + this.icon;
            if (this.size) {
                cssClass += " fa-" + this.size;
            }
            return cssClass;
        },
        enumerable: true,
        configurable: true
    });
    IconComponent.prototype.ngOnInit = function () {
    };
    return IconComponent;
}());
export { IconComponent };
